// ==========================================================================
// components/Sheet.tsx — side panel on desktop, bottom sheet on the phone.
// Used for every add / edit form in Money (and anywhere else that wants it).
// ==========================================================================
import type { ReactNode } from "react";
import { X } from "lucide-react";

export default function Sheet({ title, onClose, children, wide = false }: { title: string; onClose: () => void; children: ReactNode; wide?: boolean }) {
  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center bg-black/30 lg:items-stretch lg:justify-end" onClick={onClose}>
      <div className={`max-h-[92vh] w-full overflow-y-auto rounded-t-lg bg-surface p-6 shadow-soft lg:max-h-none ${wide ? "lg:w-[min(960px,92vw)]" : "lg:w-[460px]"} lg:rounded-none`} onClick={(e) => e.stopPropagation()}>
        <div className="mb-5 flex items-center justify-between">
          <h2 className="font-heading text-xl font-semibold">{title}</h2>
          <button type="button" onClick={onClose} aria-label="Close" className="rounded-full p-1 text-ink-muted hover:bg-surface-raised hover:text-ink"><X className="h-5 w-5" /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export const inputCls = "w-full rounded-md border border-line bg-bg px-3 py-2.5 text-ink outline-none focus:border-primary";

export function Lbl({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <label className="block space-y-1">
      <span className="text-sm font-medium text-ink-muted">{label}</span>
      {children}
      {hint && <span className="block text-xs text-ink-muted">{hint}</span>}
    </label>
  );
}
